import { render } from "./OurServices.vue?vue&type=template&id=07274e2c&ts=true"
import script from "./OurServices.vue?vue&type=script&lang=ts"
export * from "./OurServices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__